import PromotionResource from "./promotion.resource";

const promotionModule = angular
  .module("app.resources.promotion", [])
  .service("Promotion", PromotionResource);

export default promotionModule;



// WEBPACK FOOTER //
// ./src/resources/promotion/promotion.module.js